import React from "react";
import Hero from "../components/hero/Hero";
import QuickLinksSection from "../components/sections/QuickLinksSection";
import FeaturesSection from "../components/sections/FeaturesSection";
import ProgramsSection from "../components/sections/ProgramsSection";
import AboutSection from "../components/sections/AboutSection";
import TransportSection from "../components/sections/TransportSection";
import TeachersSection from "../components/sections/TeacherSection";
import FacilitiesSection from "../components/sections/FacilitiesSection";
import TestimonialsSection from "../components/sections/TestimonialsSection";
import Layout from "../components/Layout";

const Home = () => {
  return (
    <Layout>
      <Hero />
      <QuickLinksSection />
      <AboutSection />
      <FeaturesSection />
      <ProgramsSection />
      <TransportSection />
      <TeachersSection />
      <FacilitiesSection />
      <TestimonialsSection />
    </Layout>
  );
};

export default Home;
